import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SideBar, NavBar, Footer } from "./components";
import { useAuth } from "./context/authContext";
import ProfileSetup from "./screens/profile-setup";

const DashboardLayout = () => {
  const location = useLocation();
  const { client, profileChecked } = useAuth();
  const [currentScreen, setCurrentScreen] = useState("Dashboard");
  const [showSidebar, setShowSidebar] = useState(false);
  const needsProfileSetup = profileChecked && !client;

  useEffect(() => {
    if (needsProfileSetup) {
      setCurrentScreen("Profile Setup");
      return;
    }

    const path = location.pathname.split("/").filter(Boolean).pop() || "Dashboard";
    const screenNames = {
      dashboard: "Dashboard",
      statement: "Account Statement",
      "power-splitter-meters": "Power Splitter Meters",
    };

    if (screenNames[path]) {
      setCurrentScreen(screenNames[path]);
      return;
    }

    const formattedScreen = path
      .replace(/([A-Z])/g, " $1")
      .trim()
      .replace(/\b\w/g, (char) => char.toLowerCase())
      .replace(/^(\w)/, (char) => char.toUpperCase());

    setCurrentScreen(formattedScreen);
  }, [location.pathname, needsProfileSetup]);

  return (
    <div className="flex font-nexa bg-fixed w-full min-h-screen bg-lightBackground overflow-hidden relative">

      {/* Sidebar: responsive */}
      {!needsProfileSetup && (
        <SideBar
          setCurrentScreen={setCurrentScreen}
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
        />
      )}

      {/* Overlay for mobile when sidebar is open */}
      {showSidebar && !needsProfileSetup && (
        <div
          className="fixed inset-0 bg-primary-dark bg-opacity-30 z-40 lg:hidden"
          onClick={() => setShowSidebar(false)}
        />
      )}

      {/* Main content */}
      <div className="flex gap-3 p-3 w-full h-screen transition-all duration-300 overflow-y-auto scrollbar-thin scrollbar-thumb-subText scrollbar-track-white">
        <div className="flex flex-col min-w-0 flex-1 gap-3 p-3">
          <div className={`w-full ${showSidebar ? "hidden sm:block" : ""}`}>
            <NavBar
              currentScreen={currentScreen}
              showSidebar={showSidebar}
              setShowSidebar={setShowSidebar}
              hideSidebarToggle={needsProfileSetup}
            />
          </div>
          {needsProfileSetup ? <ProfileSetup embedded /> : <Outlet />}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
